import './ccf-message-outline-icon.module.scss';
import { SvgIcon,SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfMessageOutlineIconProps extends SvgIconProps {}

/**
 * CcfMessageOutlineIcon used to disply meesage outline icon in the contact card panel
 * @param props - CcfMessageOutlineIconProps
 * @example -- <CcfMessageOutlineIcon />
 */
export function CcfMessageOutlineIcon(props: CcfMessageOutlineIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Action_Message" clipPath="url(#clip-Action_Message)">
        <g id="comment" transform="translate(2.399 2.4)">
          <path id="Path_25011" data-name="Path 25011" d="M16.711,1.6H2.489a.84.84,0,0,0-.889.889V13.156a.84.84,0,0,0,.889.889H4.267v2.667a.854.854,0,0,0,.533.8.534.534,0,0,0,.356.089,1.263,1.263,0,0,0,.533-.178l4.178-3.378h6.844a.84.84,0,0,0,.889-.889V2.489A.84.84,0,0,0,16.711,1.6Zm-.889,10.667H9.6a1.263,1.263,0,0,0-.533.178l-3.022,2.4V13.156a.84.84,0,0,0-.889-.889H3.378V3.378H15.822v8.889Z"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfMessageOutlineIcon;
